var _path, _path2, _g, _path3, _path4, _g2, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoHardworq(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 327,
    height: 140,
    viewBox: "0 0 327 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8141_70860",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 266,
    y: 46,
    width: 47,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M295.959 94H275.316C272.637 94 270.158 92.7891 268.515 90.6757C266.871 88.5624 266.312 85.8654 266.977 83.2765L274.891 52.4583C275.867 48.6558 279.296 46 283.23 46H303.873C306.553 46 309.031 47.2109 310.675 49.3243C312.318 51.4376 312.877 54.1345 312.213 56.7235L304.298 87.5417C303.322 91.3442 299.893 94 295.959 94ZM279.088 84.1917H293.69C294.468 84.1917 295.148 83.6647 295.341 82.9114L301.756 57.9344C302.031 56.8572 301.217 55.8108 300.104 55.8108H285.502C284.724 55.8108 284.044 56.3379 283.851 57.0912L277.436 82.0681C277.161 83.1454 277.975 84.1917 279.088 84.1917Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8141_70860)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8141_70860",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 265,
    y: 44,
    width: 49,
    height: 52
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M313.775 44.7168H265.414V95.2852H313.775V44.7168Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8141_70860)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 265.301,
    y: 44.627,
    width: 48.4742,
    height: 50.7201,
    fill: "#A739B0"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_8141_70860)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 287.003,
    cy: 91.5089,
    rx: 23.3328,
    ry: 19.2833,
    fill: "#FE0027"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_8141_70860)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 270.418,
    cy: 84.3737,
    rx: 12.1485,
    ry: 18.7048,
    fill: "#E9195A"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_8141_70860)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 280.422,
    cy: 56.878,
    rx: 14.2991,
    ry: 22.3959,
    transform: "rotate(19.8344 280.422 56.878)",
    fill: "#D42989"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_8141_70860",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 294,
    y: 72,
    width: 25,
    height: 22
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M316.777 92.393C316.666 92.8223 316.269 93.1128 315.826 93.0974C308.762 92.8557 305.985 89.2641 303.455 86.6185C301.291 84.3561 299.207 82.8007 295.059 82.5616C294.464 82.5281 294.047 81.9625 294.194 81.3866L296.231 73.5066C296.358 73.0233 296.803 72.6916 297.303 72.7045C305.73 72.9564 307.794 76.9106 310.584 79.826C312.503 81.8314 314.989 82.9652 317.864 83.2197C318.523 83.2789 318.972 83.9113 318.807 84.5489L316.779 92.393H316.777Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_8141_70860)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_8141_70860",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 292,
    y: 71,
    width: 29,
    height: 24
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M320.127 71.4209H292.873V94.3848H320.127V71.4209Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_8141_70860)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 292.75,
    y: 71.4053,
    width: 27.4522,
    height: 23.077,
    fill: "url(#paint0_linear_8141_70860)"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M325.39 83.2246H321.355C320.912 83.2246 320.528 83.528 320.425 83.9573L318.519 91.9145C318.375 92.5161 318.831 93.092 319.449 93.092H323.483C323.927 93.092 324.31 92.7886 324.413 92.3593L326.32 84.4021C326.464 83.8005 326.008 83.2246 325.39 83.2246Z",
    fill: "#FF005D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6865 51.1338L31.4113 86.6571H22.7577L25.3392 71.9315H11.8796L9.29808 86.6571H0.644531L6.91979 51.1338H15.5733L13.0935 65.1014H26.5531L29.033 51.1338H37.6865Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8629 80.3844H47.6039L44.3658 86.6598H35.3086L54.4365 51.1338H64.4551L71.0324 86.6571H61.8736L60.8602 80.3819L60.8629 80.3844ZM59.8496 73.807L57.776 60.6496L50.9954 73.807H59.8521H59.8496Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M104.128 53.6398C106.051 55.3095 107.012 57.4766 107.012 60.141C107.016 60.871 106.948 61.5996 106.808 62.3161C106.404 64.6787 105.376 66.787 103.721 68.6409C102.067 70.4948 99.8573 71.8103 97.0918 72.5875L102.81 86.6567H93.0443L88.035 73.247H85.9615L83.5832 86.6571H74.9297L81.2049 51.1338H95.7274C99.4029 51.1338 102.203 51.9691 104.128 53.6398ZM98.0561 61.6108C98.0561 60.5324 97.7106 59.6971 97.0195 59.1048C96.3266 58.5161 95.3064 58.2209 93.9587 58.2191H88.5951L87.0267 67.1254H92.3902C93.9766 67.1254 95.233 66.7373 96.1596 65.961C97.0862 65.1848 97.6853 64.0881 97.957 62.6711C98.0249 62.1319 98.0588 61.7776 98.0588 61.6083L98.0561 61.6108Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M135.986 52.8791C138.364 54.0435 140.186 55.6794 141.451 57.7868C142.717 59.8967 143.349 62.3679 143.348 65.2003C143.323 66.4388 143.205 67.6736 142.994 68.8941C142.386 72.3694 141.079 75.4562 139.07 78.1547C137.077 80.8417 134.453 82.9968 131.43 84.43C128.343 85.9147 124.945 86.6571 121.234 86.6571H107.926L114.201 51.1338H127.51C130.781 51.1338 133.607 51.7156 135.986 52.8791ZM130.141 76.537C132.3 74.7161 133.65 72.1693 134.189 68.8967C134.341 68.0617 134.425 67.2158 134.442 66.3673C134.442 63.872 133.683 61.9408 132.165 60.5739C130.647 59.2069 128.488 58.5237 125.686 58.5242H121.537L117.892 79.2721H121.992C125.264 79.2721 127.98 78.3612 130.14 76.5395L130.141 76.537Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M197.834 51.1338L182.298 86.6571H171.824L170.256 63.3275L160.287 86.6571H149.813L147.08 51.1338H156.341L156.898 76.9929L167.779 51.1338H177.344L178.863 76.8417L188.527 51.1338H197.837H197.834Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M203.874 85.1406C201.64 83.9346 199.803 82.1069 198.586 79.8786C197.338 77.6175 196.714 75.0195 196.713 72.0846C196.713 67.935 197.607 64.2325 199.396 60.9773C201.119 57.7881 203.706 55.1486 206.859 53.3605C210.047 51.5396 213.666 50.6288 217.714 50.6279C220.751 50.6279 223.416 51.2436 225.708 52.4748C227.95 53.6564 229.798 55.4684 231.022 57.6873C232.27 59.9302 232.894 62.503 232.895 65.4056C232.895 69.5553 232.001 73.2751 230.212 76.5652C228.492 79.7845 225.895 82.4513 222.723 84.2575C219.517 86.0966 215.873 87.0161 211.793 87.0161C208.79 87.0161 206.15 86.3918 203.874 85.1431L203.874 85.1406ZM218.98 77.2971C220.68 76.1335 222.035 74.5336 222.903 72.6655C223.837 70.697 224.312 68.5424 224.294 66.3636C224.294 63.9363 223.619 62.0303 222.27 60.6459C220.92 59.2614 219.031 58.5705 216.601 58.573C214.374 58.573 212.409 59.1459 210.707 60.2917C209.005 61.4372 207.642 63.0188 206.76 64.8712C205.833 66.778 205.369 68.8786 205.369 71.1731C205.369 73.6004 206.044 75.5151 207.394 76.9169C208.743 78.3188 210.649 79.0188 213.111 79.0169C215.338 79.0169 217.294 78.4436 218.98 77.2971Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M263.486 53.6398C265.408 55.3095 266.369 57.4768 266.369 60.1416C266.373 60.8716 266.305 61.6002 266.166 62.3167C265.762 64.6794 264.733 66.7876 263.079 68.6415C261.425 70.4954 259.215 71.811 256.449 72.5882L262.167 86.6574H252.401L247.392 73.247H245.319L242.941 86.6571H234.287L240.562 51.1338H255.085C258.76 51.1338 261.561 51.9691 263.486 53.6398ZM257.413 61.6108C257.413 60.5324 257.067 59.6971 256.376 59.1048C255.683 58.5161 254.663 58.2209 253.315 58.2191H247.952L246.384 67.1254H251.747C253.334 67.1254 254.59 66.7373 255.517 65.961C256.443 65.1848 257.042 64.0881 257.315 62.6709C257.383 62.1317 257.417 61.7775 257.417 61.6081L257.413 61.6108Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_8141_70860",
    x: 248.243,
    y: 56.7989,
    width: 77.5193,
    height: 69.4197,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.71332,
    result: "effect1_foregroundBlur_8141_70860"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_8141_70860",
    x: 242.843,
    y: 50.2423,
    width: 55.1502,
    height: 68.2625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.71332,
    result: "effect1_foregroundBlur_8141_70860"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_8141_70860",
    x: 253.401,
    y: 23.6849,
    width: 54.0423,
    height: 66.387,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.78499,
    result: "effect1_foregroundBlur_8141_70860"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8141_70860",
    x1: 296.04,
    y1: 72.707,
    x2: 316.839,
    y2: 93.2494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D42A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6535,
    stopColor: "#FF005D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHardworq);
export default __webpack_public_path__ + "static/media/logo-hardworq.937a1703e41f8ffb8b4523ee0864730e.svg";
export { ForwardRef as ReactComponent };